module.exports = __webpack_public_path__ + "img/avatar_blue.fe9b4942.png";